import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SummarySectionsList from './SummarySectionsList';
import { CloseButton } from '../../shared/svg/components';
import SaveConfigurationService from '../../services/SaveConfigurationService';
import DownloadPdfService from '../../services/DownloadPdfService';
import {
  changeIsSummaryOpened,
  downloadPdf,
  initializeSections,
  initializeSummaryCameras,
  saveConfiguration,
  setPopupState, updateSections,
} from '../../model/configuratorSlice';
import { PopupState } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';

const SummaryPanel = () => {
  const {
    settings, isSummaryOpened, user, summaryShots, isPublic,
  } = useSelector(state => state.configurator);
  const [topShot, setTopShot] = useState(null);
  const [bottomShot, setBottomShot] = useState(null);

  const saveConfigurationMutation = SaveConfigurationService();
  const downloadPdfMutation = DownloadPdfService();
  const dispatch = useDispatch();

  useEffect(() => {

  }, [summaryShots]);

  useEffect(() => {
    if (isSummaryOpened) {
      dispatch(initializeSummaryCameras());
      dispatch(updateSections());

      if (summaryShots != null && summaryShots.length === 2) {
        setTopShot(summaryShots[0]);
        setBottomShot(summaryShots[1]);
      }
    }
  }, [isSummaryOpened]);

  useEffect(() => {

  }, [summaryShots]);

  const isUserLoggedIn = () => user !== null && user.isLoggedIn;

  return (
    <div className={`summary-panel ${isSummaryOpened ? 'opened' : ''}`}>
      <div className="summary-content">
        <div className="left-container">
          <div className="top-image">
            {topShot !== null && (
              <img src={`${settings.shots_base_url}/${topShot}.jpg`} alt="" />
            )}
          </div>
          <div className="bottom-image">
            {bottomShot !== null && (
              <img src={`${settings.shots_base_url}/${bottomShot}.jpg`} alt="" />
            )}
          </div>
          {/* eslint-disable-next-line max-len */}
          {/* <div className="legal-text">Los materiales, acabados y calidades mostrados son una representación virtual y pueden diferir de la realidad. A su vez, el piso representado se trata de un piso piloto que no tiene porque corresponder con ninguna vivienda ni con la seleccionada. Tanto los precios como las opciones pueden cambiar sin previo aviso por parte de la promotora y no serán vinculantes hasta su formalización y firma.</div> */}
        </div>
        <div className="right-container">
          <button
            className="close-button"
            type="button"
            onClick={() => dispatch(changeIsSummaryOpened(false))}
          ><CloseButton className="close-default" />
          </button>
          <SummarySectionsList />
          <div className={`summary-buttons-container${isUserLoggedIn() ? ' logged-in' : ''}`}>
            {isUserLoggedIn() ? (
              <button
                className="request-budget-button"
                type="button"
                onClick={() => dispatch(setPopupState(PopupState.RequestBudget))}
              >
                {TranslationUtility.GetFormattedMessageForUI('ui-summary-request-budget-button', 'Formalizar')}
              </button>
            ) : null }
            <button
              className="save-button"
              type="button"
              hidden={isPublic}
              onClick={() => {
                saveConfigurationMutation.mutate();
                dispatch(saveConfiguration());
              }}
            >
              {TranslationUtility.GetFormattedMessageForUI('ui-summary-save-budget-button', 'Guardar')}
            </button>
            <button
              className="download-button"
              type="button"
              onClick={() => {
                downloadPdfMutation.mutate();
                dispatch(downloadPdf());
                dispatch(changeIsSummaryOpened(false));
              }}
            >
              {TranslationUtility.GetFormattedMessageForUI('ui-summary-download-pdf-button', 'Descargar Resumen')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryPanel;
